// Single source of truth for site-wide constants
export const SITE = {
  name: "Midnight Sun Working Dog Coalition",
  short: "MSWDC",
  tagline: "We don't chase crisis, We stand watch over it.",
  email: "info@midnightsunworkingdogscoalition.com",
  phone: "907-229-5836",
  phoneHref: "tel:+19072295836",
  address: "4310 E 4th Avenue, Anchorage, AK 99508",
  // Replace with your actual Givebutter campaign URL anytime.
  givebutterUrl: "https://givebutter.com/mswdc-support-page-bhiz7b",
};

export const INQUIRY_TYPES = [
  "Partnership",
  "Licensing",
  "General",
  "Press",
  "Volunteer",
];
